// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 48px;
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(9, 11, 18, 0.72);
  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
  border-bottom: 1px solid var(--border);
}

.navbar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex-shrink: 0;
}

.navbar-logo img {
  height: 32px;
  width: 32px;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(255, 122, 61, 0.35));
}

.navbar-wordmark {
  font-family: var(--font-display);
  font-size: 19px;
  font-weight: 600;
  color: var(--text);
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.navbar-wordmark .accent {
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hamburger {
  display: none;
  font-size: 22px;
  background: none;
  border: none;
  color: var(--text);
  cursor: pointer;
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  transition: background var(--fast) var(--ease);
}

.hamburger:hover {
  background: var(--surface-hover);
}

.navbar-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
  flex: 1 1;
  justify-content: center;
}

.navbar-links a {
  display: inline-block;
  color: var(--text-muted);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: var(--radius-full);
  transition: color var(--fast) var(--ease), background var(--fast) var(--ease);
}

.navbar-links a:hover {
  color: var(--text);
  background: var(--surface-hover);
}

.navbar-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.auth-links {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: var(--text-muted);
}

.auth-links > a {
  color: var(--text-muted);
  text-decoration: none;
  font-weight: 500;
  transition: color var(--fast) var(--ease);
}

.auth-links > a:hover {
  color: var(--text);
}

.auth-links > a.cta {
  color: #1a0e05;
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  padding: 8px 18px;
  border-radius: var(--radius-full);
  font-weight: 600;
  transition: box-shadow var(--fast) var(--ease), transform var(--fast) var(--ease);
}

.auth-links > a.cta:hover {
  color: #1a0e05;
  box-shadow: var(--shadow-accent);
  transform: translateY(-1px);
}

.user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--surface);
  border: 1px solid var(--border);
  padding: 5px 14px 5px 6px;
  border-radius: var(--radius-full);
  color: var(--text);
  font-size: 13px;
  font-weight: 500;
}

.user-chip .avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-start), var(--accent-end));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #1a0e05;
  flex-shrink: 0;
}

.auth-links .logout-button {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-muted);
  cursor: pointer;
  padding: 7px 16px;
  border-radius: var(--radius-full);
  font-size: 13px;
  transition: all var(--fast) var(--ease);
}

.auth-links .logout-button:hover {
  color: var(--text);
  border-color: var(--border-strong);
  background: var(--surface-hover);
}

/* Responsive */
@media (max-width: 1028px) {
  .navbar {
    flex-wrap: wrap;
    padding: 10px 24px;
  }

  .hamburger {
    display: block;
    order: 2;
  }

  .navbar-logo {
    order: 1;
  }

  .navbar-actions {
    order: 3;
    margin-left: auto;
  }

  .navbar-links {
    display: none;
    flex-direction: column;
    width: 100%;
    order: 4;
    align-items: stretch;
    padding-top: 10px;
    gap: 2px;
  }

  .navbar-links.open {
    display: flex;
  }

  .navbar-links a {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iCAAiC;EACjC,0CAA0C;EAC1C,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2EAA2E;EAC3E,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2EAA2E;EAC3E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;IACR,oBAAoB;IACpB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".navbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 12px 48px;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background: rgba(9, 11, 18, 0.72);\n  backdrop-filter: blur(16px) saturate(140%);\n  -webkit-backdrop-filter: blur(16px) saturate(140%);\n  border-bottom: 1px solid var(--border);\n}\n\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.navbar-logo img {\n  height: 32px;\n  width: 32px;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 8px rgba(255, 122, 61, 0.35));\n}\n\n.navbar-wordmark {\n  font-family: var(--font-display);\n  font-size: 19px;\n  font-weight: 600;\n  color: var(--text);\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n\n.navbar-wordmark .accent {\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.hamburger {\n  display: none;\n  font-size: 22px;\n  background: none;\n  border: none;\n  color: var(--text);\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  transition: background var(--fast) var(--ease);\n}\n\n.hamburger:hover {\n  background: var(--surface-hover);\n}\n\n.navbar-links {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  gap: 4px;\n  flex: 1;\n  justify-content: center;\n}\n\n.navbar-links a {\n  display: inline-block;\n  color: var(--text-muted);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: var(--radius-full);\n  transition: color var(--fast) var(--ease), background var(--fast) var(--ease);\n}\n\n.navbar-links a:hover {\n  color: var(--text);\n  background: var(--surface-hover);\n}\n\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.auth-links {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.auth-links > a {\n  color: var(--text-muted);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color var(--fast) var(--ease);\n}\n\n.auth-links > a:hover {\n  color: var(--text);\n}\n\n.auth-links > a.cta {\n  color: #1a0e05;\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  padding: 8px 18px;\n  border-radius: var(--radius-full);\n  font-weight: 600;\n  transition: box-shadow var(--fast) var(--ease), transform var(--fast) var(--ease);\n}\n\n.auth-links > a.cta:hover {\n  color: #1a0e05;\n  box-shadow: var(--shadow-accent);\n  transform: translateY(-1px);\n}\n\n.user-chip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  padding: 5px 14px 5px 6px;\n  border-radius: var(--radius-full);\n  color: var(--text);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.user-chip .avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent-start), var(--accent-end));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: #1a0e05;\n  flex-shrink: 0;\n}\n\n.auth-links .logout-button {\n  background: none;\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 7px 16px;\n  border-radius: var(--radius-full);\n  font-size: 13px;\n  transition: all var(--fast) var(--ease);\n}\n\n.auth-links .logout-button:hover {\n  color: var(--text);\n  border-color: var(--border-strong);\n  background: var(--surface-hover);\n}\n\n/* Responsive */\n@media (max-width: 1028px) {\n  .navbar {\n    flex-wrap: wrap;\n    padding: 10px 24px;\n  }\n\n  .hamburger {\n    display: block;\n    order: 2;\n  }\n\n  .navbar-logo {\n    order: 1;\n  }\n\n  .navbar-actions {\n    order: 3;\n    margin-left: auto;\n  }\n\n  .navbar-links {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    order: 4;\n    align-items: stretch;\n    padding-top: 10px;\n    gap: 2px;\n  }\n\n  .navbar-links.open {\n    display: flex;\n  }\n\n  .navbar-links a {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
